import React, { useState } from 'react';
import Navbar from './components/Navbar';
import Header from './components/Header';
import Searchbar from './components/SearchBar';
import HistoryBar from './components/HistoryBar';
import { useTheme } from './components/ThemeContext';
import { Menu } from 'lucide-react';

interface HomeProps {
    setSearchQuery?: (query: string) => void;
}

const Home: React.FC<HomeProps> = ({ setSearchQuery }) => {
    const { theme } = useTheme();
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    return (
        <div className={`min-h-screen flex ${theme === 'dark' ? 'bg-dark-bg-primary text-dark-text-primary' : 'bg-white text-neutral-900'}`}>
            {/* Sidebar */}
            <HistoryBar
                isOpen={isSidebarOpen}
                onClose={() => setIsSidebarOpen(false)}
                onToggle={toggleSidebar}
            />

            {/* Main Content */}
            <div className={`flex-1 flex flex-col transition-all duration-300 ${isSidebarOpen ? 'md:ml-[280px]' : 'md:ml-16'}`}>
                {/* Mobile Menu Button */}
                <button
                    onClick={toggleSidebar}
                    className={`
                        md:hidden fixed top-4 left-4 z-50 p-2 rounded-lg
                        ${theme === 'dark' ? 'bg-dark-bg-elevated text-dark-text-primary' : 'bg-white text-neutral-900 shadow-md'}
                        ${isSidebarOpen ? 'opacity-0 pointer-events-none' : 'opacity-100'}
                        transition-opacity
                    `}
                >
                    <Menu size={24} />
                </button>

                {/* Navbar */}
                <div className="w-full">
                    <Navbar />
                </div>

                {/* Main content area */}
                <main className="flex-grow px-4 sm:px-8 pb-24 max-w-4xl mx-auto w-full flex flex-col items-center justify-center space-y-8 pt-8">
                    <Header />
                    <div className="w-full max-w-3xl">
                        <Searchbar />
                    </div>
                </main>

                {/* Footer */}
                <footer className={`w-full mt-auto border-t ${theme === 'dark' ? 'border-dark-border bg-dark-bg-secondary' : 'border-neutral-200 bg-neutral-50'}`}>
                    <div className="max-w-4xl mx-auto px-4 sm:px-8 py-6">
                        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                            <p className={`text-sm ${theme === 'dark' ? 'text-dark-text-tertiary' : 'text-neutral-600'}`}>
                                © {new Date().getFullYear()} VerdictAI. All rights reserved.
                            </p>
                            <p className={`text-xs ${theme === 'dark' ? 'text-dark-text-tertiary' : 'text-neutral-500'}`}>
                                Developed with ❤️ for the betterment of legal research
                            </p>
                        </div>
                    </div>
                </footer>
            </div>
        </div>
    );
}

export default Home;

